import React, { useEffect, useRef } from "react";
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import FormSelectionField from "../../../components/formFields/FormSelectionField";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import ButtonWithLoading from "../../../components/common/ButtonWithLoading";
import { Typography } from "@progress/kendo-react-common";
import { requiredValidator } from "../../../components/formFields/CommonValidator";
import ShadowCard from "../../../components/common/ShadowCard";
import { getKarigarListByProcess } from "../../karigar/services/karigar.services";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import {
  clearGhatPendingOrderReportDetails,
  clearGhatPendingOrderReportList,
  setGhatPendingOrderReportDetails,
} from "../reportSlice";

import { IKarigarListByProcess } from "../../karigar/karigarModel";
import FormDatePicker from "../../../components/formFields/FormDateField";
import moment from "moment";
import { getGhatPendingOrderReport } from "../services/reports.services";
import { Button } from "@progress/kendo-react-buttons";
import { PiMicrosoftExcelLogoFill } from "react-icons/pi";
import { IoMdPrint } from "react-icons/io";
import { checkAcessRights, formatWeight } from "../../../_helper/helper";
import {
  EXCEL_EXPORT_ACCESS,
  PRINT_ACCESS,
  PROCESS_ID,
} from "../../../_contstants/common";
import { useLocation } from "react-router-dom";
import AlertBox from "../../../components/common/AlertBox";

const GhatPendingOrderReport: React.FC = () => {
  const dispatch = useAppDispatch();
  const tablecontentRef = useRef<any>(null);
  const loading = useAppSelector((state) => state.reports.loading);
  const location = useLocation();
  const isExcelExportAccess = checkAcessRights(
    location.pathname,
    EXCEL_EXPORT_ACCESS
  );
  const isPrintAccess = checkAcessRights(location.pathname, PRINT_ACCESS);
  const GhatPendingOrderReportList = useAppSelector(
    (state) => state.reports.GhatPendingOrderReportList
  );

  const GhatPendingOrderReportDetails = useAppSelector(
    (state) => state.reports.GhatPendingOrderReportDetails
  );
  const KarigarListByProcess = useAppSelector(
    (state) => state.karigar?.KarigarListByProcess
  );

  useEffect(() => {
    dispatch(getKarigarListByProcess(PROCESS_ID.ghat));
    return () => {
      dispatch(clearGhatPendingOrderReportDetails());
      dispatch(clearGhatPendingOrderReportList());
    };
  }, []);

  const handleSubmit = async (values: any) => {
    try {
      const payload = {
        from_date: values.from_date
          ? moment(values.from_date).format("YYYY-MM-DD")
          : "",
        to_date: values.to_date
          ? moment(values.to_date).format("YYYY-MM-DD")
          : "",
        karigar_id: values.karigar_id ? +values.karigar_id : null,
      };

      await dispatch(getGhatPendingOrderReport(payload));
      dispatch(
        setGhatPendingOrderReportDetails({
          from_date: values?.from_date,
          to_date: values?.to_date,
          karigar_id: values?.karigar_id,
        })
      );
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      throw error;
    }
  };

  const handleExportExcel = () => {
    /*===*===* YOUR TABLE *===*===*/
    const table = document.querySelector(".reports-table") as HTMLTableElement;
    if (!table) return;
    const workbook = new ExcelJS.Workbook();
    /*===*===* YOUR SHEET NAME *===*===*/
    const worksheet = workbook.addWorksheet(`Sheet 1`);
    const rows = Array.from(table.querySelectorAll("tr"));
    let excelRowIndex = 1; // Excel row index (1-based)
    const occupiedCells: Record<string, boolean> = {}; // Track occupied cells
    const colWidths: number[] = [];

    rows.forEach((row, rowIndex) => {
      const cells = Array.from(row.children) as HTMLTableCellElement[];
      let colIndex = 1; // Reset to first column for each row

      cells.forEach((cell) => {
        const cellContent = cell.textContent?.trim() || "";
        const cellLength = cellContent.length;
        const colSpan = cell.colSpan || 1;
        const rowSpan = cell.rowSpan || 1;

        colWidths[colIndex] = Math.max(
          colWidths[colIndex] || 10,
          cellLength + 2
        );
        /*===*===* Find the next available column (skip occupied columns) *===*===*/
        while (occupiedCells[`${excelRowIndex}-${colIndex}`]) {
          colIndex++;
        }
        /*===*===* SET VALUE AND TABLE STYLE *===*===*/
        const excelCell = worksheet.getRow(excelRowIndex).getCell(colIndex);
        const numericValue = Number(cellContent.replace(/,/g, ""));
        if (
          !isNaN(numericValue) &&
          cellContent.replace(/,/g, "").match(/^\d+(\.\d+)?$/)
        ) {
          excelCell.value = numericValue; // Store as a real number
        } else {
          excelCell.value = cellContent; // Store as text
        }
        // excelCell.value = cellContent;
        excelCell.alignment = { horizontal: "center", vertical: "middle" };
        excelCell.border = {
          top: { style: "thin", color: { argb: "000000" } },
          bottom: { style: "thin", color: { argb: "000000" } },
          left: { style: "thin", color: { argb: "000000" } },
          right: { style: "thin", color: { argb: "000000" } },
        };

        /*===*===* HEADER STYLE *===*===*/
        if (rowIndex === 0) {
          excelCell.font = { bold: true };
          excelCell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "95c2ff" },
          };
        }
        /*===*===* LAST ROW STYLE *===*===*/
        // if (rowIndex === rows.length - 1) {
        //   excelCell.font = { bold: true };
        //   excelCell.fill = {
        //     type: "pattern",
        //     pattern: "solid",
        //     fgColor: { argb: "D9E1F2" },
        //   };
        // }
        /*===*===* HANDEL colSpan AND rowSpan *===*===*/
        if (colSpan > 1 || rowSpan > 1) {
          const startCell = worksheet
            .getRow(excelRowIndex)
            .getCell(colIndex).address;
          const endCell = worksheet
            .getRow(excelRowIndex + rowSpan - 1)
            .getCell(colIndex + colSpan - 1).address;
          worksheet.mergeCells(`${startCell}:${endCell}`);
          // Mark merged cells as occupied
          for (let r = 0; r < rowSpan; r++) {
            for (let c = 0; c < colSpan; c++) {
              occupiedCells[`${excelRowIndex + r}-${colIndex + c}`] = true;
            }
          }
        }
        colIndex += colSpan;
      });

      excelRowIndex++; // Move to next row
    });

    worksheet.columns = colWidths.map((width) => ({ width }));
    /*===*===* SAVE THE FILE  *===*===*/
    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      saveAs(
        blob,
        `ghat_issue_pending_order_report_${moment().format(
          "DD-MM-YYYY_hh-mm-A"
        )}.xlsx`
      );
    });
  };

  const printTable = () => {
    const fromDate = GhatPendingOrderReportDetails?.from_date;
    const toDate = GhatPendingOrderReportDetails?.to_date;

    const DateFromTo = `( ${moment(fromDate).format("DD/MM/YYYY")} to ${moment(
      toDate
    ).format("DD/MM/YYYY")} )`;
    const ReportTitle = "Ghat Issue Pending Order Report";
    const table = document.querySelector(
      ".reports-table"
    ) as HTMLElement | null;

    if (!table) {
      window.print();
      return;
    }

    // Create a new window in full screen
    const printWindow = window.open("", "_blank", "fullscreen=yes");
    if (!printWindow) {
      alert(
        "Popup blocker prevented opening print window. Please allow popups for this site."
      );
      return;
    }

    // Try to maximize the window (browser dependent)
    printWindow.moveTo(0, 0);
    printWindow.resizeTo(screen.width, screen.height);

    // Store original styles
    const originalStyles = {
      maxHeight: table.style.maxHeight,
      minWidth: table.querySelector("table")?.style.minWidth || "",
    };

    // Clone the table and its styles
    const tableClone = table.cloneNode(true) as HTMLElement;

    // Optimize table for printing
    tableClone.style.maxHeight = "none";
    const tableElement = tableClone.querySelector("table");
    if (tableElement) {
      tableElement.style.minWidth = "100%";
      tableElement.style.fontSize = "12px";
    }

    // Create print HTML content
    const printContent = `
        <!DOCTYPE html>
        <html>
        <head>
            <title>Reports Print</title>
            <style>
                html, body {
                    height: 100%;
                    margin: 0;
                    padding: 0;
                    font-family: Arial, sans-serif;
                    background: white;
                }
                .container {
                    min-height: 100vh;
                    padding: 20px;
                    display: flex;
                    flex-direction: column;
                }
                .print-header {
                    text-align: center;
                    margin-bottom: 20px;
                    padding: 15px;
                    border-bottom: 2px solid #333;
                    flex-shrink: 0;
                }
                .print-header h1 {
                    margin: 0;
                    font-size: 28px;
                    color: #333;
                }
                .print-header p {
                    margin: 5px 0 0 0;
                    font-size: 16px;
                    color: #666;
                }
                .reports-table {
                    width: 100%;
                    max-height: none !important;
                    overflow: visible !important;
                    flex: 1;
                }
                .reports-table table {
                    width: 100% !important;
                    min-width: 100% !important;
                    font-size: 14px;
                    border-collapse: collapse;
                }
                .reports-table th,
                .reports-table td {
                    padding: 10px;
                    border: 1px solid #ddd;
                    page-break-inside: avoid;
                }
                .reports-table th {
                    background-color: #f8f9fa !important;
                    color: #000 !important;
                    font-weight: bold;
                }
                @media print {
                    body {
                        padding: 0;
                        margin: 0;
                    }
                    .container {
                        padding: 0;
                    }
                    .print-header {
                        margin-bottom: 15px;
                        padding: 10px;
                    }
                    @page {

                        margin: 0.5cm;
                    }
                    .reports-table th {
                        background-color: #f8f9fa !important;
                        -webkit-print-color-adjust: exact;
                        print-color-adjust: exact;
                    }
                }
            </style>
        </head>
        <body>
            <div class="container">
                <div class="print-header">
                    <h1>${ReportTitle}</h1>
                    <p>${DateFromTo}</p>
                </div>
                <div class="reports-table">
                    ${tableClone.innerHTML}
                </div>
            </div>
            <script>
                window.onload = function() {
                    // Try to enter fullscreen (may require user gesture)
                    if (document.documentElement.requestFullscreen) {
                        document.documentElement.requestFullscreen().catch(err => {
                            console.log('Fullscreen error:', err);
                        });
                    }

                    // Print after a short delay
                    setTimeout(function() {
                        window.print();
                    }, 500);
                };

                // Close window after printing
                window.onafterprint = function() {
                    // Exit fullscreen first if active
                    if (document.exitFullscreen) {
                        document.exitFullscreen();
                    }
                    setTimeout(function() {
                        window.close();
                    }, 100);
                };

                // Also handle manual close
                window.onbeforeunload = function() {
                    if (document.exitFullscreen) {
                        document.exitFullscreen();
                    }
                };
            </script>
        </body>
        </html>
    `;

    // Write content to new window
    printWindow.document.open();
    printWindow.document.write(printContent);
    printWindow.document.close();

    // Restore original styles
    table.style.maxHeight = originalStyles.maxHeight;
    if (tableElement) {
      tableElement.style.minWidth = originalStyles.minWidth;
      tableElement.style.fontSize = "";
    }

    // Focus on the print window
    printWindow.focus();
  };

  return (
    <GridLayout cols={[{ width: "100%" }]}>
      <GridLayoutItem>
        <ShadowCard>
          <Form
            initialValues={GhatPendingOrderReportDetails}
            onSubmit={handleSubmit}
            render={(formRenderProps: FormRenderProps) => (
              <FormElement style={{ width: "100%" }}>
                <GridLayout
                  style={{ marginRight: 20 }}
                  gap={{ rows: 0, cols: 10 }}
                  cols={[
                    { width: "33.33%" },
                    { width: "33.33%" },
                    { width: "33.33%" },
                  ]}
                >
                  <GridLayoutItem colSpan={3}>
                    <Typography.h4
                      style={{ marginBottom: 0, marginLeft: "3px" }}
                    >
                      Ghat Pending Order Report
                    </Typography.h4>
                  </GridLayoutItem>
                  <GridLayoutItem style={{ display: "flex", gap: 10 }}>
                    <Field
                      wrapperStyle={{ width: "100%" }}
                      name="from_date"
                      label="From Date"
                      format="dd/MM/yyyy"
                      component={FormDatePicker}
                      validator={requiredValidator}
                      astrike={true}
                    />
                    <Field
                      wrapperStyle={{ width: "100%" }}
                      name="to_date"
                      label="To Date"
                      format="dd/MM/yyyy"
                      minDate={
                        moment(
                          formRenderProps.valueGetter("from_date")
                        ).toDate() || new Date(1900, 0, 1)
                      }
                      component={FormDatePicker}
                      validator={requiredValidator}
                      astrike={true}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name="karigar_id"
                      label="Karigar"
                      placeholder="Select Karigar"
                      component={FormSelectionField}
                      options={KarigarListByProcess?.map(
                        (karigar: IKarigarListByProcess) => {
                          return {
                            value: karigar?.id,
                            label: `${karigar?.karigar_name}`,
                          };
                        }
                      )}
                      validator={requiredValidator}
                      astrike={true}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem
                    style={{
                      position: "relative",
                    }}
                  >
                    <ButtonWithLoading
                      label="GET DETAILS"
                      type="submit"
                      style={{ position: "absolute", top: 42 }}
                      disabled={!formRenderProps.allowSubmit || loading}
                      loading={loading}
                    />
                  </GridLayoutItem>
                </GridLayout>
              </FormElement>
            )}
          />
        </ShadowCard>
        {/* REPORT LIST */}
        {(GhatPendingOrderReportList?.PendingOrderList ||
          GhatPendingOrderReportList?.PendingApprovalItem) &&
        (GhatPendingOrderReportList?.PendingOrderList?.length > 0 ||
          GhatPendingOrderReportList?.PendingApprovalItem?.length > 0) ? (
          <ShadowCard style={{ marginTop: 10 }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: 10,
              }}
            >
              <Typography.h5 style={{ marginBottom: 0 }}>
                Ghat Pending Order Report
              </Typography.h5>
              <div
                className="printbuttons"
                style={{
                  textAlign: "center",
                  display: "block",
                }}
              >
                {isExcelExportAccess && (
                  <Button
                    type="button"
                    fillMode={"solid"}
                    themeColor={"primary"}
                    onClick={handleExportExcel}
                    style={{
                      marginRight: "10px",
                      padding: "5px 10px",
                      border: "none",
                      backgroundColor: "#3b823b",
                    }}
                  >
                    <PiMicrosoftExcelLogoFill style={{ fontSize: "20px" }} />{" "}
                    Excel Export
                  </Button>
                )}
                {isPrintAccess && (
                  <Button
                    type="button"
                    style={{
                      marginRight: "10px",
                      padding: "5px 10px",
                      border: "none",
                    }}
                    fillMode={"solid"}
                    themeColor={"primary"}
                    onClick={printTable}
                  >
                    <IoMdPrint style={{ fontSize: "20px" }} /> Print Report
                  </Button>
                )}
              </div>
            </div>
            <div
              className="table-responsive reports-table "
              style={{ maxHeight: "calc(100vh - 300px)" }}
              ref={tablecontentRef}
            >
              {GhatPendingOrderReportList?.PendingOrderList?.length > 0 && (
                <>
                  <h5 className="fw-bold">Order Item</h5>
                  <table
                    className="table table-striped table-bordered table-hover"
                    style={{ minWidth: 1500 }}
                  >
                    <thead>
                      <tr>
                        <th style={{ width: "8%" }}>Issue Date</th>
                        <th style={{ width: "12%" }}>Approx Delivery Date</th>
                        <th style={{ width: "10%" }}>Category</th>
                        <th style={{ width: "18%" }}>Product</th>
                        <th style={{ width: "10%" }}>Estimate Weight (gm)</th>
                        <th style={{ width: "12%" }}>Karigar</th>
                        <th style={{ width: "8%" }}>Process</th>
                        <th style={{ width: "12%" }}>Remarks</th>
                      </tr>
                    </thead>
                    <tbody>
                      {GhatPendingOrderReportList &&
                        GhatPendingOrderReportList?.PendingOrderList?.length >
                          0 &&
                        GhatPendingOrderReportList?.PendingOrderList?.map(
                          (item, index) => {
                            return (
                              <tr key={index}>
                                <td>{item?.issue_date}</td>
                                <td>{item?.approx_delivery_date}</td>
                                <td>{item?.category_name}</td>
                                <td>{item?.item_name}</td>
                                <td>{formatWeight(item?.estimate_weight)}</td>
                                <td>{item?.karigar_name}</td>
                                <td>{item?.process_name}</td>
                                <td>{item?.remarks}</td>
                              </tr>
                            );
                          }
                        )}
                    </tbody>
                  </table>
                </>
              )}

              {GhatPendingOrderReportList?.PendingApprovalItem?.length > 0 && (
                <>
                  <h5 className="fw-bold">Approval Item</h5>
                  <table
                    className="table table-striped table-bordered table-hover"
                    style={{ minWidth: 1500, marginTop: 10 }}
                  >
                    <thead>
                      <tr>
                        <th style={{ width: "15%" }}>Type</th>
                        <th style={{ width: "40%" }}>Product</th>
                        <th style={{ width: "15%" }}>Weight (gm)</th>
                        <th style={{ width: "15%" }}>Quantity</th>
                        <th style={{ width: "15%" }}>Unit</th>
                      </tr>
                    </thead>
                    <tbody>
                      {GhatPendingOrderReportList &&
                        GhatPendingOrderReportList?.PendingApprovalItem
                          ?.length > 0 &&
                        GhatPendingOrderReportList?.PendingApprovalItem?.map(
                          (item, index) => {
                            return (
                              <tr key={index}>
                                <td>{item?.type}</td>
                                <td>{item?.item_name}</td>
                                <td>{formatWeight(item?.weight)}</td>
                                <td>{item?.qty}</td>
                                <td>{item?.unit_name}</td>
                              </tr>
                            );
                          }
                        )}
                    </tbody>
                  </table>
                </>
              )}
            </div>
          </ShadowCard>
        ) : (
          GhatPendingOrderReportDetails?.karigar_id && <AlertBox />
        )}
      </GridLayoutItem>
    </GridLayout>
  );
};

export default GhatPendingOrderReport;
